import React from 'react';

function UsersSoftwarePage() {
    return <div>Users Product Software Page</div>;
}

export default UsersSoftwarePage;
